import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import DatePicker from '../../../components/DatePicker';
import HelpText from '../../../../../components/HelpText';
import Validate from '../../../../../components/Validation/Validate';
import ErrorMessage from '../../../../../components/Validation/ErrorMessage';
import { required, optional } from '../../../../../utils/validation/validator';
import CurrencySelector from '../../../components/CurrencySelector';

export class CancellationExpensesListItem extends React.Component {

  onDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    // this.setState({
    //   item: { ...this.props.item, ...{ [propertyName]: value } },
    // }, () => {
    //   this.change();
    // });
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove && this.props.total > 1) {
      this.props.onRemove(this.props.item.id);
    }
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };

  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const { item } = this.props;
    const {
      disabled,
      validatorGroup,
      validationCounter,
      removable,
    } = this.props;
    const refundFieldValidator =
      item.refundCompensationReceived > 0 ? required : optional;

    return (
      <div className="secondary-background expenses">
        <div className={'row align-items-center'}>
          {!disabled &&
            removable && (
              <div className={'form-group col-auto mb-02'}>
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className={'form-group col-auto mb02'}>
            <PageSectionHeader>
              <FormattedMessage
                {...messages.cancellationExpenseTitle}
                values={{ index: this.props.index + 1 }}
              />
            </PageSectionHeader>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-3 col-sm-5 mb02">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.dateCancelled}
                fieldName={messages.cancellationExpensesDateCancelled}
              >
                <DatePicker
                  disabled={disabled}
                  type="text"
                  onDayChange={this.onDayChange('dateCancelled')}
                  value={item.dateCancelled}
                  placeholder=""
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.cancellationExpensesDateCancelled}
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>
          </div>
          <div className="form-group col-md-5 col-sm-7 mb02">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.cancelledBookingDescription}
                fieldName={
                  messages.cancellationExpensesCancelledBookingDescription
                }
              >
                <Textbox
                  disabled={disabled}
                  type="text"
                  onChange={this.onChange('cancelledBookingDescription')}
                  value={item.cancelledBookingDescription}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={
                      messages.cancellationExpensesCancelledBookingDescription
                    }
                  />
                </ErrorMessage>
              </Validate>
              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Flight to Paris' }}
                />
              </HelpText>
            </FlexBox>
          </div>
          <div className="form-group col-md-4 col-sm-6 mb02">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.supplier}
              fieldName={messages.cancellationExpensesSupplier}
            >
              <Textbox
                disabled={disabled}
                type="text"
                onChange={this.onChange('supplier')}
                value={item.supplier}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.cancellationExpensesSupplier}
                />
              </ErrorMessage>
            </Validate>
            <HelpText>
              <FormattedMessage
                {...messages.textBoxEg}
                values={{ value: 'Qantas' }}
              />
            </HelpText>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6 col-sm-6 mb02">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.prePaidAmount}
              fieldName={messages.cancellationExpensesPrePaidAmount}
            >
              <Textbox
                disabled={disabled}
                type="number"
                onChange={this.onChange('prePaidAmount')}
                value={item.prePaidAmount}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.cancellationExpensesPrePaidAmount}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-6 col-sm-6 mb02">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.prePaidAmountCurrency}
              fieldName={messages.cancellationExpensesCurrency}
            >

              <CurrencySelector
                onChange={this.handleCurrencyChange('prePaidAmountCurrency')}
                disabled={disabled}
                value={item.prePaidAmountCurrency}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.cancellationExpensesCurrency}
                />
              </ErrorMessage>
            </Validate>

            <HelpText>
              <FormattedMessage
                {...messages.textBoxEg}
                values={{ value: 'Euro' }}
              />
            </HelpText>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-4 col-sm-4">
            {item.refundCompensationReceived > 0 && <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[refundFieldValidator]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.dateRefundWasReceived}
                fieldName={messages.dateRefundWasReceived}
              >
                <DatePicker
                  disabled={disabled}
                  type="text"
                  onDayChange={this.onDayChange('dateRefundWasReceived')}
                  value={item.dateRefundWasReceived}
                  placeholder=""
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.dateRefundWasReceived}
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>}
            {(!item.refundCompensationReceived || item.refundCompensationReceived <= 0) && <div className="w-full">
              <PageSectionHeader>
                <FormattedMessage {...messages.dateRefundWasReceived} />
              </PageSectionHeader>
              <DatePicker
                disabled={disabled}
                type="text"
                onDayChange={this.onDayChange('dateRefundWasReceived')}
                value={item.dateRefundWasReceived}
                placeholder=""
              />

            </div>}
          </div>
          <div className="form-group col-md-4 col-sm-4">

            <PageSectionHeader>
              <FormattedMessage {...messages.cancellationExpensesRefundCompensationReceived} />
            </PageSectionHeader>
            <Textbox
              disabled={disabled}
              type="number"
              onChange={this.onChange('refundCompensationReceived')}
              value={item.refundCompensationReceived}
            />

          </div>
          <div className="form-group col-md-4 col-sm-4">
            {item.refundCompensationReceived > 0 && <FlexBox direction={'column'}>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[refundFieldValidator]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.refundCompensationReceivedCurrency}
                fieldName={messages.cancellationExpensesCurrency}
              >

                <CurrencySelector
                  onChange={this.handleCurrencyChange('refundCompensationReceivedCurrency')}
                  disabled={disabled}
                  value={item.refundCompensationReceivedCurrency}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.cancellationExpensesCurrency}
                  />
                </ErrorMessage>
              </Validate>
              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Euro' }}
                />
              </HelpText>
            </FlexBox>}
            {(!item.refundCompensationReceived || item.refundCompensationReceived <= 0) && <FlexBox direction={'column'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.cancellationExpensesCurrency} />
              </PageSectionHeader>
              <CurrencySelector
                onChange={this.handleCurrencyChange('refundCompensationReceivedCurrency')}
                disabled={disabled}
                value={item.refundCompensationReceivedCurrency}
              />
              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Euro' }}
                />
              </HelpText>
            </FlexBox>}
          </div>
        </div>
      </div>
    );
  }
}

CancellationExpensesListItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  total: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepCancellationAdditional/components/CancellationExpenses/CancellationExpensesListItem.js